import React, {Component} from 'react';
import {Pagination, InputNumber, message} from 'antd';
import {Redirect} from 'react-router';
import './goodsDetail.less';

class GoodsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 1, // 购买的商品数量
      detail: {}, // 商品详情
      redirect: false,
      total: null, // 总页数
      currentPage: 1, // 当前页
      id: null, // 当前商品或套餐的id
      type: null, // 当前商品或套餐的类型
      goodsPackageList: [], // 当为软件时，获取关联套餐列表
    };
  }

  async componentWillMount() {
    if (window.common.loginOut(this)) {
      const info = this.props.location.state;
      await this.setState({id: info.id, type: info.type});
      info.type === 'goods' ? this.getSetMealList() : null;
      this.getDetail(info.id, info.type);
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  async componentWillReceiveProps(props) {
    const info = props.location.state;
    await this.setState({id: info.id, type: info.type});
    info.type === 'goods' ? this.getSetMealList() : null;
    this.getDetail(info.id, info.type);
  }

  // 跳转到生成订单页
  toOrder = () => {
    const {detail, count} = this.state;
    if (Number(detail.goods_num) === 0) {
      message.warn('库存数量为0，无法购买');
      return;
    }
    if (Number(detail.status) === 1) {
      message.warn('该产品已下架，无法购买');
      return;
    }
    if (count === undefined) {
      message.warn('请填写您要购买的数量');
      return;
    }
    const info = {
      img: detail.goods_picture,
      count,
      id: detail.id,
      type: this.state.type
    };
    let other = {};
    if (this.state.type === 'goods') {
      other = {
        price: detail.sale_price,
        name: detail.goods_name,
        discount: detail.discount_price,
        is_post: detail.is_post,
      };
    } else {
      other = {
        price: detail.package_amt,
        name: detail.package_name,
        discount: detail.package_amt,
        is_post: Number(detail.package_is_post),
      };
    }
    Object.assign(info, other);
    this.props.history.push('/generateOrder', {info});
  }

  // 改变购买数量
  changeCount = (value) => {
    const {detail, type} = this.state;
    if (type === 'goods') {
      if (detail.goods_num > 25 && value === 25) {
        message.warn('单次最多购买25件商品');
        this.setState({count: 25});
        return;
      }
      if (detail.goods_num > 0 && detail.goods_num < 25 && value === detail.goods_num) {
        message.warn(`最多购买${detail.goods_num}件`);
        this.setState({count: value});
        return;
      }
    }
    this.setState({count: value});
  }

  // 获取商品信息
  getDetail = () => {
    const {currentPage, id, type} = this.state;
    let url = 'goods.getgoodsdetail';
    let params = {id};
    if (type === 'setMeal') {
      url = 'eps.getgoodspackageinfo';
      params = {id, package_detail_page_no: currentPage, package_detail_page_num: 5};
    }
    window.api(url, params).then(res => {
      console.log(res);
      if (type === 'goods') {
        res.sale_price = (res.sale_price).toFixed(2);
        res.discount_price = (res.discount_price).toFixed(2);
        res.max = res.goods_num > 25 ? 25 : res.goods_num;
        this.setState({detail: res});
      } else {
        const detail = res.goods_package;
        detail.goods_picture = detail.package_picture;
        detail.goods_name = detail.package_name;
        detail.goods_details = detail.package_details;
        detail.max = detail.goods_num;
        this.setState({detail: res.goods_package});
      }
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 获取商品关联套餐列表
  getSetMealList() {
    const params = {
      goods_id: this.state.id,
      page_no: this.state.currentPage,
      page_num: 5,
    };
    window.api('eps.getgoodspackagebygoods', params).then(res => {
      this.setState({goodsPackageList: res.goods_package_list, total: Number(res.count)});
    }).catch((error) => {
      if (error.service_error_code === 'EPS000000801') {
        this.setState({redirect: true});
        message.error(error.service_error_message);
      }
    });
  }

  // 跳转到详情页
  toDetail = (id, type) => {
    this.props.history.push('/goodsDetail', {id, type});
  }

  // 分页
  changePage = async (page) => {
    await this.setState({currentPage: Number(page)});
    this.state.type === 'goods' ? this.getSetMealList() : this.getDetail();
  }

  render() {
    const {
      redirect, detail, currentPage, total, type, goodsPackageList
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div id="goodsDetail">
        <section className="sale">
          <div className="poster">
            <img src={detail.goods_picture} />
          </div>
          <div className="orderInfo">
            <h3>{detail.goods_name}</h3>
            {type === 'goods' ? <div className="price">
              {detail.discount_price !== detail.sale_price ? <p>折扣价：</p> : <p>价格：</p>}
              <p className="salePrice"><em>￥</em>{detail.discount_price}</p>
              <p className="salePrice" hidden={detail.discount_price === detail.sale_price}>￥{detail.sale_price}</p>
            </div> : <div className="price">
              <p>套餐价：</p>
              <p className="salePrice"><em>￥</em>{detail.package_amt}</p>
            </div>}
            <div className="info">
              <p>运费：免运费</p>
              <p>24小时发货</p>
              <p style={type === 'setMeal' ? {visibility: 'hidden'} : null}>销量：{detail.sell_out}</p>
            </div>
            <div className="count">
              <p style={{paddingRight: '10px'}}>数量：</p>
              <div>
                <InputNumber min={1} max={detail.max} defaultValue={1} onChange={this.changeCount} />
              </div>
              <p className="stock" style={type === 'setMeal' ? {visibility: 'hidden'} : null}>剩余：{detail.goods_num}</p>
            </div>
            <button onClick={this.toOrder} className={detail.goods_num === 0 || detail.status === 1 ? 'cantBuy' : null}>立即购买</button>
          </div>
        </section>
        {
          detail.goods_package_detail_list && detail.goods_package_detail_list.length > 0 ? <section className="setMeal" hidden={type === 'goods'}>
            <div className="title">搭配商品</div>
            <ul className="list">
              {
                detail.goods_package_detail_list.map((item, index) => (
                  <li key={index} onClick={this.toDetail.bind(this, item.goods_id, 'goods')}>
                    <img src={item.goods_picture} alt="" />
                    <p>{item.goods_name}</p>
                    <p><text style={{color: '#fc3339'}}>￥{item.sale_price}</text> x {item.goods_amount}</p>
                  </li>
                ))
              }
            </ul>
            <Pagination
              className="pagination"
              showQuickJumper
              showSizeChange
              current={currentPage}
              defaultCurrent={1}
              defaultPageSize={5}
              total={Number(detail.goods_package_detail_count)}
              onChange={this.changePage}
            />
          </section> : null
        }
        {
          goodsPackageList.length > 0 ? <section className="setMeal" hidden={type === 'setMeal'}>
            <div className="title">相关套餐推荐</div>
            <ul className="list">
              {
                goodsPackageList.map((item, index) => (
                  <li key={index} onClick={this.toDetail.bind(this, item.id, 'setMeal')}>
                    <img src={item.package_picture} alt="" />
                    <p>{item.package_name}</p>
                    <p><text style={{color: '#fc3339'}}>￥{item.package_amt}</text></p>
                  </li>
                ))
              }
            </ul>
            <Pagination
              className="pagination"
              showQuickJumper
              showSizeChange
              current={currentPage}
              defaultCurrent={1}
              defaultPageSize={5}
              total={Number(total)}
              onChange={this.changePage}
            />
          </section> : null
        }
        <section className="detail">
          <div className="title">{type === 'goods' ? '商品详情' : '套餐详情'}</div>
          <div className="content" dangerouslySetInnerHTML={{__html: detail.goods_details}} />
        </section>
      </div>
    );
  }
}

export default GoodsDetail;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/goodsDetail/goodsDetail.jsx